// src/utils/whatsappSender.js
import { doc, getDoc } from 'firebase/firestore';
import { db } from '../firebase';

/**
 * Send WhatsApp Order Confirmation via Meta Cloud API
 * Reads config from Firestore 'settings/whatsapp-order'
 */
export const sendWhatsAppOrderConfirmation = async (phone, customerName, orderId, total) => {
  try {
    // 1. Fetch WhatsApp Order plugin config
    const configRef = doc(db, 'settings', 'whatsapp-order');
    const configSnap = await getDoc(configRef);

    if (!configSnap.exists()) {
      return { success: false, error: 'Plugin not configured' };
    }

    const config = configSnap.data();

    // 2. Check if enabled
    if (config.orderConfirmationEnabled === false) {
      return { success: false, error: 'Plugin disabled' };
    }

    if (!config.accessToken || !config.phoneNumberId) {
      return { success: false, error: 'Missing credentials' };
    }

    // 3. Clean phone
    const cleanPhone = phone.replace(/[^0-9]/g, '');

    // 4. Build payload
    const templateName = config.templateName || 'order_confirmation';
    const templateLanguage = config.templateLanguage || 'en_US';

    const payload = {
      messaging_product: 'whatsapp',
      to: cleanPhone,
      type: 'template',
      template: {
        name: templateName,
        language: { code: templateLanguage },
        components: [
          {
            type: 'body',
            parameters: [
              { type: 'text', text: customerName || 'Customer' },
              { type: 'text', text: orderId || 'N/A' },
              { type: 'text', text: total?.toString() || '0' },
            ],
          },
        ],
      },
    };

    // 5. Send to Meta Cloud API
    const response = await fetch(
      `https://graph.facebook.com/v20.0/${config.phoneNumberId}/messages`,
      {
        method: 'POST',
        headers: {
          'Authorization': `Bearer ${config.accessToken}`,
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(payload),
      }
    );

    const data = await response.json();

    if (!response.ok) {
      console.error('WhatsApp API error:', data);
      return {
        success: false,
        error: data.error?.message || 'API failed',
      };
    }

    console.log('✅ WhatsApp sent:', data);
    return { success: true };
  } catch (error) {
    console.error('WhatsApp error:', error);
    return { success: false, error: error.message };
  }
};

export default sendWhatsAppOrderConfirmation;